import React from 'react';
import { Modal, CircularProgress, Typography, Box, Grid, Stack, IconButton } from '@mui/material';
import MultipleVouchers from './MultipleVouchers';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

const style = (voucherData) => ({
    position: 'absolute',
    top: { xs: 'auto', sm: '50%' },
    bottom: { xs: 0, sm: 'auto' },
    left: '50%',
    transform: { xs: 'translateX(-50%)', sm: 'translate(-50%, -50%)' },


    width: { xs: '100vw', sm: 'auto' },
    height: {
        xs: voucherData?.vouchers?.length > 1 ? '85vh' : '70vh',
        sm: "70vh"
    },
    maxWidth: { xs: '100%', sm: '95%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderTopLeftRadius: { xs: 16, sm: 16 },
    borderTopRightRadius: { xs: 16, sm: 16 },
    borderBottomLeftRadius: { xs: 0, sm: 16 },
    borderBottomRightRadius: { xs: 0, sm: 16 },
    overflow: 'hidden',
    border: 0,
    display: 'flex',
    flexDirection: 'column',
});


const MultiVouchersLoading = () => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            overflow: 'auto',
            height: '100%',
        }}
    >
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2, fontFamily: 'Be Vietnam Pro' }}>
            Loading...
        </Typography>
    </Box>
);

function VoucherView({ voucherData, onClose }) {
    return (
        <Modal
            open={voucherData?.showVoucher}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Box sx={style(voucherData)}>
                {false ? (
                    <Box
                        sx={{
                            height: { xs: '100%', sm: '80vh' },
                            maxHeight: { xs: '70vh', sm: '80vh' },
                            width: { xs: '100vw', sm: 600, lg: 700 },
                            overflow: 'auto',
                        }}
                    >
                        <MultiVouchersLoading />
                    </Box>
                ) : (
                    <HandleVouchersShow
                        voucherData={voucherData}
                        onClose={onClose}
                    />
                )}
            </Box>
        </Modal>
    );
}

function HandleVouchersShow({ voucherData, onClose }) {


    const vouchersArray = voucherData?.vouchers ?? [];
    const hasVouchers = vouchersArray.length > 0;
    const isSingle = vouchersArray.length === 1;

    const hideScrollbar = {
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    };

    return (
        <React.Fragment>
            {/* HEADER SECTION */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 2,
                    px: { xs: 2, sm: 3 },
                    backgroundColor: '#FFF',
                    borderBottom: '1px solid #F3F4F6'
                }}
            >
                <Stack spacing={0.5}>
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{
                            color: "primary.main",
                            fontFamily: 'Be Vietnam Pro',
                            fontWeight: 600,
                            fontSize: { xs: "1.2rem", sm: "1.8rem" },
                        }}
                    >
                        Voucher Details
                    </Typography>

                    <Typography
                        id="modal-modal-subtitle"
                        variant="body2"
                        sx={{
                            color: "text.secondary",
                            fontFamily: 'Be Vietnam Pro',
                            fontWeight: 500,
                            fontSize: { xs: "11px", sm: "14px" }
                        }}
                    >
                        View and Manage Your Voucher code and Pin
                    </Typography>
                </Stack>

                <IconButton
                    onClick={onClose}
                    sx={{
                        bgcolor: 'red.main',
                        color: "#FFF",
                        borderRadius: 2,
                        p: { xs: 0.5, sm: 1 },
                        "&:hover": {
                            color: "#000",
                            border: "1px solid #C62828 "
                        }
                    }}
                >
                    <CloseIcon fontSize="medium" />
                </IconButton>
            </Box>

            {/* MAIN CONTENT CONTAINER */}
            <Box
                sx={{
                    flexGrow: 1,
                    maxHeight: {
                        xs:
                            voucherData?.vouchers?.length > 1
                                ? 'calc(85vh - 140px)'
                                : 'calc(70vh - 140px)',
                        sm: '65vh'
                    },
                    width: { xs: '100%', sm: 600, lg: 700 },
                    overflowY: 'auto',
                    overflowX: { xs: 'hidden', sm: 'auto' },
                    px: { xs: 1.5, sm: 3 },
                    py: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    ...hideScrollbar
                }}
            >
                {hasVouchers ? (
                    <Grid
                        container
                        direction="column"
                        sx={{
                            rowGap: 2,
                            py: 0,
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'block'

                        }}
                    >
                        {vouchersArray.map((v, index) => (
                            <Grid
                                item
                                key={`voucher-${v?.publicId}`}
                                xs={12}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <MultipleVouchers
                                    ProductData={voucherData?.ProductData}
                                    ProductImage={voucherData?.orderRowData}
                                    mobileVocher={voucherData}
                                    voucher={v}
                                    SingleVoucher={isSingle}
                                    onClose={onClose}
                                />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    /* EMPTY STATE FALLBACK CONDITION */
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: 4,
                            textAlign: 'center',
                            gap: 1.5
                        }}
                    >
                        <ConfirmationNumberIcon sx={{ fontSize: 48, color: '#9CA3AF' }} />
                        <Stack spacing={0.5}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontFamily: 'Be Vietnam Pro',
                                    fontWeight: 600,
                                    color: '#374151',
                                    fontSize: { xs: '1rem', sm: '1.25rem' }
                                }}
                            >
                                No Vouchers Available
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontFamily: 'Be Vietnam Pro',
                                    color: '#6B7280',
                                    maxWidth: 280,
                                    mx: 'auto',
                                    fontSize: { xs: '11px', sm: '13px' }
                                }}
                            >
                                There are no active voucher codes linked with this item details context profile.
                            </Typography>
                        </Stack>
                    </Box>
                )}
            </Box>

            {/* FOOTER SECTION */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'stretch', sm: 'center' },
                    justifyContent: 'space-between',
                    py: 1.5,
                    px: { xs: 2, sm: 3 },
                    backgroundColor: '#FFF',
                    borderTop: '1px solid #F3F4F6',
                    gap: { xs: 1.5, sm: 0 },
                    mt: 'auto'
                }}
            >
                <Stack spacing={0.25}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            color: "text.primary",
                            fontFamily: 'Be Vietnam Pro',
                            fontWeight: 600,
                            fontSize: { xs: '12px', sm: '14px' }
                        }}
                    >
                        Keep Your Voucher and Pin Secure
                    </Typography>

                    <Typography
                        variant="caption"
                        sx={{
                            color: "text.secondary",
                            fontFamily: 'Be Vietnam Pro',
                            fontSize: { xs: '9px', sm: '12px' }
                        }}
                    >
                        Each Code and PIN can Only Be used once and cannot be shared
                    </Typography>
                </Stack>

            </Box>
        </React.Fragment>
    );
}

export default VoucherView;